<template>
  <div class="row g-1 align-items-center">
    <div class="col-2">
      <template v-if="flight.holes.length > 0">
        <hole-column
          @click="
            onClick(
              $event,
              flight,
              flightIndex,
              currentHoleOfFlight(flight, -2)
            )
          "
          v-if="currentHoleOfFlight(flight, -2)"
          :classes="'mobile'"
          :hole="currentHoleOfFlight(flight, -2)"
          :isStartHole="
            currentHoleOfFlight(flight, -2)?.number == flight.startHole
          "
          :compact="true"
        ></hole-column>
      </template>
    </div>
    <div class="col-2">
      <template v-if="flight.holes.length > 0">
        <hole-column
          @click="
            onClick(
              $event,
              flight,
              flightIndex,
              currentHoleOfFlight(flight, -1)
            )
          "
          v-if="currentHoleOfFlight(flight, -1)"
          :classes="'mobile'"
          :hole="currentHoleOfFlight(flight, -1)"
          :isStartHole="
            currentHoleOfFlight(flight, -1)?.number == flight.startHole
          "
          :compact="true"
        ></hole-column>
        <div class="text-center" v-else>🏌️</div>
      </template>
    </div>
    <div class="col-4">
      <hole-column
        @click="
          onClick($event, flight, flightIndex, currentHoleOfFlight(flight))
        "
        v-if="flight.holes.length > 0 && currentHoleOfFlight(flight)"
        :classes="'mobile'"
        :hole="currentHoleOfFlight(flight)"
        :isStartHole="currentHoleOfFlight(flight)?.number == flight.startHole"
      ></hole-column>
    </div>
    <div class="col-2">
      <template v-if="flight.holes.length > 0">
        <hole-column
          @click="
            onClick($event, flight, flightIndex, currentHoleOfFlight(flight, 1))
          "
          v-if="currentHoleOfFlight(flight, 1)"
          :classes="'mobile'"
          :hole="currentHoleOfFlight(flight, 1)"
          :isStartHole="
            currentHoleOfFlight(flight, 1)?.number == flight.startHole
          "
          :compact="true"
        ></hole-column>
        <div class="text-center" v-else>⛳</div>
      </template>
    </div>
    <div class="col-2">
      <template v-if="flight.holes.length > 0">
        <hole-column
          @click="
            onClick($event, flight, flightIndex, currentHoleOfFlight(flight, 2))
          "
          v-if="currentHoleOfFlight(flight, 2)"
          :classes="'mobile'"
          :hole="currentHoleOfFlight(flight, 2)"
          :isStartHole="
            currentHoleOfFlight(flight, 2)?.number == flight.startHole
          "
          :compact="true"
        ></hole-column>
      </template>
    </div>
  </div>
</template>
<script>
import { defineComponent } from "vue";
import { mapGetters } from "vuex";
import HoleColumn from "./hole_column.vue";

export default defineComponent({
  props: {
    flight: Object,
    flightIndex: Number,
    onClick: Function,
  },
  components: {
    HoleColumn,
  },
  computed: {
    ...mapGetters({
      timestamp: "timeSheets/getTimestamp",
    }),
  },
  methods: {
    currentHoleOfFlight(flight, offset = 0) {
      let holeIndex = flight.holes.findIndex(
        (h) => h.targetTime >= this.timestamp
      );
      if (holeIndex >= 0) {
        return flight.holes[holeIndex + offset];
      }
      return flight.holes.length > 0
        ? flight.holes[flight.holes.length - 1 + offset]
        : null;
    },
  },
});
</script>
